import styled from '@emotion/styled';

import useLoadingStore from 'zustands/useLoadingStore';
import 'App.css';

const Wrap = styled.div`
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
const LoadTitleArea = styled.div`
  margin-top: 2%;
`;
const LoadTitleText = styled.strong`
  color: #999;
`;
const LoadTextArea = styled.div``;
const LoadTextText = styled.strong`
  color: #999;
`;

const FetchLoading = () => {
  const { isFetchLoading, title, text } = useLoadingStore();

  if (isFetchLoading === false) return null;
  return (
    <Wrap>
      <div className="loader">
        {/* <Loader size='large' type={'infinite-spinner'} /> */}
        <div className="spinner">
          <div className="rect1"></div>
          <div className="rect2"></div>
          <div className="rect3"></div>
          <div className="rect4"></div>
          <div className="rect5"></div>
        </div>
        <LoadTitleArea>
          <LoadTitleText>{title}</LoadTitleText>
        </LoadTitleArea>
        <LoadTextArea>
          <LoadTextText>{text}</LoadTextText>
        </LoadTextArea>
      </div>
    </Wrap>
  );
};

export default FetchLoading;
